import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

// APIの住所を設定します。
const unpaidServices = (memberId: string): any => {
  return {
    getUnpaid: () => apiClient.get(`${API_BASE_ADDRESS}/member/${memberId}/unpaid`),
  };
};

export default unpaidServices;
